import './style/index.js';

import _Alert from './alert';

export type { AlertProps } from './alert';

export const Alert = _Alert;
export default Alert;
